import React from "react";
// 💎 Single source of truth for Sellox lifetime plans (all landing pages, every country, USD).
export const SAAS_PLANS = [
  { key: "basico", setup: 350, mant: 100, stores: 1, cashiers: 5, online: false },
  { key: "negocio", setup: 899, mant: 250, stores: 2, cashiers: 10, online: true, popular: true },
  { key: "empresa", setup: 1499, mant: 450, stores: 4, cashiers: 20, online: true },
  { key: "insignia", setup: 1999, mant: 600, stores: 999, cashiers: 30, online: true },
];

const NAMES = {
  basico: { zh: "基础版", es: "Básico", en: "Basic", pt: "Básico" },
  negocio: { zh: "商业版", es: "Negocio", en: "Business", pt: "Negócio" },
  empresa: { zh: "企业版", es: "Empresa", en: "Enterprise", pt: "Empresa" },
  insignia: { zh: "旗舰版", es: "Insignia", en: "Flagship", pt: "Premium" },
};
export const planName = (key, lang) => (NAMES[key] || {})[lang] || (NAMES[key] || {}).es || key;

export const PLAN_TEXT = {
  es: { yearly: "/año nube + mantenimiento", stores: (n) => n >= 999 ? "Tiendas ilimitadas" : `${n} ${n === 1 ? "tienda" : "tiendas"}`, cashiers: (n) => `${n} cajeros`, once: "Pago único · licencia de por vida", popular: "Más popular", buy: "Comprar" },
  en: { yearly: "/yr cloud + maintenance", stores: (n) => n >= 999 ? "Unlimited stores" : `${n} ${n === 1 ? "store" : "stores"}`, cashiers: (n) => `${n} cashiers`, once: "One-time payment · lifetime license", popular: "Most popular", buy: "Buy" },
  pt: { yearly: "/ano nuvem + manutenção", stores: (n) => n >= 999 ? "Lojas ilimitadas" : `${n} ${n === 1 ? "loja" : "lojas"}`, cashiers: (n) => `${n} caixas`, once: "Pagamento único · licença vitalícia", popular: "Mais popular", buy: "Comprar" },
  zh: { yearly: "/年 云端+维护", stores: (n) => n >= 999 ? "门店不限" : `${n} 家店`, cashiers: (n) => `${n} 个收银员`, once: "一次买断 · 终身授权", popular: "最受欢迎", buy: "购买" },
};

// 🔄 Live prices from the super-admin "套餐价格" page (falls back to the defaults above until loaded / offline).
let _cache = null;
export function useSaasPlans() {
  const [plans, setPlans] = React.useState(_cache || SAAS_PLANS);
  React.useEffect(() => {
    if (_cache) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/public/saas-plans`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && Array.isArray(d.plans) && d.plans.length) { _cache = d.plans; setPlans(d.plans); } })
      .catch(() => {});
  }, []);
  return plans;
}
